import React, { useEffect, useRef } from 'react';
const Team = () => {
  const sectionRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (entry.target.classList.contains('section-hidden')) {
            entry.target.classList.remove('section-hidden');
            entry.target.classList.add('animate-fadeIn');
          }
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      sectionRef.current.classList.add('section-hidden');
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  const teamMembers = [{
    name: 'Richard Edebiri',
    title: 'Chairman/CEO',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1JBxna3GB2qfp9rspSfNkv/unnamed_%284%29.jpg',
    bio: ['Richard Edebiri currently serves as the Chairman/Chief Executive Officer of Socrates and Richard Company Ltd. Prior to his current role, he gathered valuable experience as the Project Manager with Greenrich Nigeria Company.', 'Richard has a HND in Building Technology from Federal Polytechnic, Nasarawa, a Bachelors degree in Material and Production Engineering from Ambrose Alli University, Ekpoma and a Masters in Science Degree (M.Sc) in Project Management from the prestigious Robert Gordon University, Aberdeen, Scotland - UK.', 'He is an experienced manager, team leader and motivator with great interpersonal skills, team building skills and has the ability to deliver projects under tough circumstances.']
  }, {
    name: 'Ojemeiwanlan James Braimah',
    title: 'Associate Architect and Project Manager',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tk8xzG4unDg2K6bB1sUmfS/unnamed_%2811%29.jpg',
    bio: ["Ojemeiwanlan James Braimah is an Associate Architect and Project Manager with over a decade of hands-on experience in architectural design and construction. He holds both Bachelor's and Master's degrees in Architecture from Ambrose Alli University, Ekpoma, grounding him strongly in sustainable design, spatial planning, and building performance.", 'A committed professional, James is an Associate Member of the Nigerian Institute of Architects (NIA), Edo State Chapter, reflecting his dedication to industry standards and continuous growth.', 'He specializes in creating sustainable architectural spaces that align with client needs while enhancing quality of life. His work blends thoughtful design with effective project management marked by clarity, precision, and responsibility.', 'His core competencies include conceptual design, construction documentation, project supervision, space optimization, budgeting, site coordination, and client relations. He is also skilled in modern building technologies, sustainable materials, and quality workmanship.']
  }, {
    name: 'Osayande Elvis',
    title: 'Site Engineer and Procurement Manager',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/puj3hBEZP8bFTfb3HANoB5/unnamed_%2812%29.jpg',
    bio: ['Osayande Elvis is a structural engineer currently serving as a Site Engineer and Procurement Manager at Socrates and Richard Company Limited, a role he has held for nearly two years. He holds a degree in Structural Engineering from the University of Benin, where he built a strong foundation in building design, analysis, and construction processes.', 'Elvis has contributed to multiple building projects, including the Ebo Primary School development and several residential and commercial structures. His experience spans structural design, building analysis, site supervision, and project coordination.', 'In addition to engineering expertise, he is skilled in procurement management—particularly in negotiating and securing quality materials at optimal prices, ensuring efficiency and cost-effectiveness across projects.']
  }];
  return <div className="w-full pt-20" data-id="element-740">
      {/* Hero Section */}
      <section className="relative py-20 bg-gray-900" data-id="element-741">
        <div className="absolute inset-0 z-0 opacity-30" data-id="element-742">
          <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Team collaboration" className="w-full h-full object-cover" data-id="element-743" />
        </div>
        <div className="container mx-auto px-4 md:px-6 relative z-10 text-center" data-id="element-744">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 animate-fadeInDown" data-id="element-745">
            Our Team
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto animate-fadeInUp" data-id="element-746">
            Meet the experienced professionals who lead our company
          </p>
        </div>
      </section>
      {/* Leadership Section */}
      <section className="py-20" ref={sectionRef} data-id="element-747">
        <div className="container mx-auto px-4 md:px-6 transition-opacity duration-1000" data-id="element-748">
          <div className="text-center mb-16" data-id="element-749">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2e1a] mb-4" data-id="element-750">
              Our Leadership
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-751">
              Dedicated professionals committed to excellence in construction
              and real estate
            </p>
          </div>
          <div className="space-y-16" data-id="element-752">
            {teamMembers.map((member, index) => <div key={member.name} className={`bg-white rounded-lg shadow-lg overflow-hidden ${index % 2 === 0 ? '' : 'bg-gray-50'}`} data-id="element-753">
                <div className={`md:flex ${index % 2 === 0 ? '' : 'md:flex-row-reverse'}`} data-id="element-754">
                  <div className="md:flex-shrink-0" data-id="element-755">
                    <img className="h-64 w-full object-cover object-top md:w-64 lg:w-80" src={member.image} alt={`${member.name} - ${member.title}`} data-id="element-756" />
                  </div>
                  <div className="p-8 flex-1" data-id="element-757">
                    <div className="uppercase tracking-wide text-sm text-[#95c11f] font-semibold" data-id="element-758">
                      {member.title}
                    </div>
                    <h3 className="mt-1 text-2xl font-bold text-[#1a2e1a] mb-4" data-id="element-759">
                      {member.name}
                    </h3>
                    <div className="space-y-3" data-id="element-760">
                      {member.bio.map((paragraph, idx) => <p key={idx} className="text-gray-700 leading-relaxed" data-id="element-761">
                          {paragraph}
                        </p>)}
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
};
export default Team;